import { render, staticRenderFns } from "./communicateDoc.vue?vue&type=template&id=29206640&scoped=true&"
import script from "./communicateDoc.vue?vue&type=script&lang=js&"
export * from "./communicateDoc.vue?vue&type=script&lang=js&"
import style0 from "./communicateDoc.vue?vue&type=style&index=0&id=29206640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29206640",
  null
  
)

export default component.exports